export default __webpack_public_path__ + "images/Ampae-Phnom_sanctuary.webp";